<template>
  <main class="main customer_search" role="main">
    <header class="header">
      <div class="inner">
        <div class="left">
          <button class="h_btn i_back" @click="$router.go(-1)"></button>
        </div>
        <h1 class="h1">
          매장 찾기
        </h1>
        <div class="right"></div>
      </div>
    </header>
    <div class="main_con">
      <div class="search_wrap">
        <div class="search_input">
          <div class="s_input">
            <input
              v-model="searchText"
              type="search"
              placeholder="어떤 매장을 찾으시나요?"
              maxlength="12"
              @keypress.enter="searchTextSend"
              ref="searchInput"
            />
          </div>
          <div class="s_del pnt" @click="searchTextDel" v-if="isCloseBtn">
            <img
              :src="require(`@/assets/front/images/new/i_x_input.svg`)"
              alt=""
            />
          </div>
          <div class="s_search pnt" @click="searchTextSend">
            <img
              :src="require(`@/assets/front/images/new/i_search_n.svg`)"
              alt=""
            />
          </div>
        </div>
        <div style="padding: 1rem 2.4rem 0 2.4rem" v-show="isValue">
          <p :class="['valid', { on: isValue }]">
            <i class="i_valid"></i>검색어를 두글자이상 입력해 주세요.
          </p>
        </div>
        <div class="result" v-if="fetchCompleted || list.length > 0">
          총 <span class="error">{{ shops.totalElements }}</span
          >개의 검색 결과
        </div>
      </div>
      <div class="store">
        <div class="store_list_wrap" v-if="isReload">
          <SkeletonStoreItem v-for="index in 5" :key="index" />
        </div>
        <div
          class="store_list_wrap"
          v-else
          :style="{
            'padding-top': fetchCompleted || list.length > 0 ? 0 : '4rem',
          }"
        >
          <Shop
            class="pnt"
            v-for="(shop, idx) in list"
            :store="shop"
            @toggle="toggleFollow(shop, shop.id, idx)"
            :key="idx"
            :shopInfo="getShopInfo(shop.id)"
            @goShopDetail="goShopDetail"
            :idx="idx"
            ref="shop"
          />
          <SkeletonStoreItem v-if="fetchCompleted && isScrolling" />
        </div>
        <!-- <div class="store_list_wrap" v-else>
          <div class="keyword_title">이런 서비스는 어떠세요?</div>
          <div class="keyword_list">
            <ul>
              <li
                v-for="(keyword, idx) in searchKeyword"
                :key="idx"
                @click="keywordSearch(keyword)"
              >
                {{ keyword }}
              </li>
            </ul>
          </div>
        </div> -->
      </div>
      <infinite-loading
        ref="infiniteLoading"
        :direction="direction"
        :identifier="infiniteId"
        @infinite="infiniteHandler"
      >
        <span slot="no-more"></span>
        <span slot="no-results"></span>
        <span slot="spinner"></span>
      </infinite-loading>
      <template v-if="fetchCompleted && list.length === 0">
        <div class="empty_wrap">
          <div class="empty result">
            <!--'기본: ', '준비중: ready', '결과없음: result'-->
            <div class="msg">
              <div>검색하신 결과가 없습니다.</div>
            </div>
          </div>
        </div>
      </template>
      <div ref="dummy"></div>
    </div>

    <DesignPopup
      @close="confirm"
      :show="designPopup"
      :data="popupParams"
    ></DesignPopup>
    <!-- <ShopDetail
      ref="shopDetail"
      @close="closeShopDetail"
      @shopFollowed="shopFollowed"
    /> -->
  </main>
</template>

<script>
import SkeletonStoreItem from '@common/components/shop/SkeletonItem/StoreItem.vue';
import Shop from './components/Shop.vue';
import ShopFilterModal from './modal/ShopFilterModal.vue';
import { mapActions, mapState, mapGetters } from '@common/store/modules/shop';
import * as shopTypes from '@common/store/modules/shop/types';
import {
  mapActions as userMapActions,
  mapGetters as userMapGetters,
} from '@common/store/modules/user';
import * as userTypes from '@common/store/modules/user/types';
import { mapActions as commonMapActions } from '@common/store/modules/common';
import * as commonActions from '@common/store/modules/common/types';
import {
  mapActions as estimateMapActions,
  mapGetters as estimateMapGetters,
} from '@common/store/modules/estimate';
import * as estimationTypes from '@common/store/modules/estimate/types';
import { authMapGetters, authGetters } from '@common/store/modules';
import DesignPopup from '@/common/components/modal/DesignPopup.vue';
import InfiniteLoading from 'vue-infinite-loading';
import { sleep, nativeDeviceInfo } from '@common/lib/common/utils';
// import ShopDetail from '@common/components/modal/ShopDetail';

import {
  mapActions as reviewMapActions,
  mapGetters as reviewMapGetters,
} from '@common/store/modules/review';
import * as reviewTypes from '@common/store/modules/review/types';
export default {
  name: 'Shops.search',
  components: {
    Shop,
    DesignPopup,
    InfiniteLoading,
    // ShopDetail,
    SkeletonStoreItem,
  },
  data() {
    return {
      isValue: false,
      // isCloseBtn: false,
      searchText: '',
      searchKeyword: [
        '알뜰폰',
        '주말영업',
        '요금수납',
        '해지',
        '휴대폰 분실',
        '주차가능',
        '중고폰 매입',
        '인터넷',
        '휴대폰 수리',
      ],
      shopIdx: 0,
      myDeviceName: '',
      myTelecomName: '',
      shopFilterModal: false,
      filter: {},
      designPopup: false,
      popupParams: {
        type: 'confirm',
        msg: '',
      },
      fetchCompleted: false,
      direction: 'top',
      infiniteId: 0,
      list: [],
      size: 10,
      page: 1,
      isReload: false,
      isScrolling: false,
      visitPage: 0, // 페이지 이동시 현재 페이지
      scrollLocation: 0, // 페이지 이동시 현재 스크롤 위치
      shopsCnt: 0,
      keyword: '',
      searching: false,
    };
  },
  computed: {
    ...mapGetters({
      shops: shopTypes.SHOPS,
      shopInfo: shopTypes.SHOP,
      shopCnt: shopTypes.SHOP_COUNT,
    }),
    ...userMapGetters({
      user: userTypes.USER,
    }),
    ...authMapGetters({
      currentUser: authGetters.CURRENT_USER,
    }),
    ...estimateMapGetters({
      autoEstimation: estimationTypes.AUTO_ESTIMATION,
    }),
    isCloseBtn() {
      if (this.searchText == '') {
        return false;
      } else {
        return true;
      }
    },
  },
  // 페이지 이동시 호출됨, 여기서는 뒤로가기시 어디서 왔는지 체크
  async beforeRouteEnter(to, from, next) {
    return next(async vm => {
      console.log(from);
      await vm.fetch(from.name);
    });
  },
  async mounted() {
    await this.fetchMe();

    // 페이징 뒤로가기 설정 시작
    this.page = 1;
    if (this.visitPage > 0 && this.searchText != '') {
      this.isReload = true;
      for (var i = 0; i < this.visitPage - 1; i++) {
        this.infiniteId += 1;
      }
    }
  },
  watch: {
    searchText() {
      if (this.searchText.trim() == '') {
        this.searchText = '';
        this.fetchCompleted = false;
      }
    },
    '$route.query.keyword'(val) {
      // alert(1);
      if (val && !this.searching) {
        this.searchText = val;
        this.getListPageOne();
        this.searching = false;
      }
    },
  },
  methods: {
    ...commonMapActions([commonActions.SET_DIALOG, commonActions.HIDE_DIALOG]),
    ...mapActions([
      shopTypes.SHOP_UNFOLLOW,
      shopTypes.SHOP_FOLLOW,
      shopTypes.FETCH_SHOP,
      shopTypes.FETCH_SHOPS,
      shopTypes.FETCH_SHOPS_SEARCH,
    ]),
    ...estimateMapActions([estimationTypes.FETCH_AUTO_ESTIMATION_IN_PROGRESS]),
    ...userMapActions([userTypes.FETCH_ME]),
    ...reviewMapActions([
      reviewTypes.FETCH_REVIEWS,
      reviewTypes.FETCH_REVIEW_CHECK,
    ]),
    openShopFilterModal(type) {
      this.shopFilterModal = true;
    },
    async fetch(fromName) {
      // 뒤로가기로 왔을때 저장된 값 확인
      if (fromName == 'Shops.Detail') {
        let visit_page = await sessionStorage.getItem(
          'visit_search_from_detail',
        );

        if (visit_page) {
          visit_page = JSON.parse(visit_page);
          this.visitPage = visit_page.page;
          this.scrollLocation = visit_page.scrollLocation;
          this.searchText = visit_page.searchText;

          // 데이터 담고 삭제
          await sessionStorage.removeItem('visit_search_from_detail');
        }
      }

      // 검색어 페이지에서 진입시
      this.keyword = this.$route.query.keyword;
      if (this.keyword) {
        this.searchText = this.keyword;
        this.searchTextSend();
      }
    },
    async fetchMe() {
      await this[userTypes.FETCH_ME]();
    },
    async getShopInfo(id) {
      //await this[shopTypes.FETCH_SHOPS](id);
    },
    searchTextDel() {
      // alert(this.searchText);
      this.searchText = '';
      this.$refs.searchInput.focus();
      // alert(this.searchText);
      this.isValue = false;
      this.fetchCompleted = false;
    },
    keywordSearch(keyword) {
      this.searchText = keyword;
      this.searchTextSend();
    },
    async searchTextSend() {
      this.searching = true;
      // alert(2);
      // 검색 페이지에서 진입시
      if (this.keyword) {
        if (!this.searchText.trim()) return;

        const recentWords =
          JSON.parse(localStorage.getItem('recent-keywords')) || [];

        recentWords.forEach((item, idx) => {
          if (item == this.searchText.trim()) recentWords.splice(idx, 1);
        });

        recentWords.unshift(this.searchText.trim());
        if (recentWords.length > 3) recentWords.splice(3);
        localStorage.setItem('recent-keywords', JSON.stringify(recentWords));

        this.$router
          .push({
            name: 'Shops.search',
            query: { keyword: this.searchText },
          })
          .catch(() => {});
      }

      this.fetchCompleted = false;
      await sleep(100);
      if (this.searchText.trim() == '') {
        this.searchText = '';
        this.isValue = true;
        this.fetchCompleted = false;
        return false;
      } else if (this.searchText.trim().length < 2) {
        this.isValue = true;
        this.fetchCompleted = false;
        return false;
      }

      this.isReload = true;
      this.visitPage = 0; // 페이지 이동시 현재 페이지
      this.scrollLocation = 0; // 페이지 이동시 현재 스크롤 위치

      this.searchText = this.searchText.trim();

      await this.getListPageOne();

      this.isValue = false;
      this.searching = false;
    },
    async getShops() {
      let params = {
        page: this.page,
        size: this.size,
        searchStr: this.searchText,
        isLoading: false,
      };
      if (this.filter.keyword) {
        params['keywordId'] = this.filter.keyword.id;
      }
      if (this.filter.follow) {
        params['follow'] = this.filter.follow;
      }
      await this[shopTypes.FETCH_SHOPS_SEARCH](params);
      this.fetchCompleted = true;
    },
    async getListPageOne() {
      this.direction = 'top';
      this.page = 1;
      this.infiniteId += 1;
    },
    async infiniteHandler($state) {
      this.isScrolling = true;
      if (this.infiniteId == 0) {
        $state.complete();
      } else {
        this.direction = 'bottom';
        await this.getShops();
        if (this.page == 1) {
          this.list = [];
        }
        if (this.shops.content.length) {
          await this.list.push(...this.shops.content);
          // 페이지 이동시 저장된 페이지 개수만큼 호출
          if (parseInt(this.visitPage, 10) - 1 > this.page) {
            setTimeout(() => {
              this.$refs.dummy.scrollIntoView({ behavior: 'auto' });
            }, 10);
          } else {
            this.isReload = false;
            // 페이지 다 호출하면 저장된 위치로 이동
            if (this.visitPage > this.page) {
              setTimeout(() => {
                window.scrollTo(0, this.scrollLocation);
              }, 100);
            }
          }
          this.page += 1;
          this.isScrolling = false;
          console.log($state);
          $state.loaded();
        } else {
          this.isReload = false;
          // 페이지 다 호출하면 저장된 위치로 이동
          setTimeout(() => {
            window.scrollTo(0, this.scrollLocation);
          }, 100);
          $state.complete();
          this.isScrolling = false;
        }
      }
    },
    async goShopDetail(shopId) {
      // 페이지 이동 전에 세션스토리지에 저장 (뒤로가기 처리하기 위함) - 시작
      let scrollLocation = document.documentElement.scrollTop; // 현재 스크롤바 위치
      const visit_page = {
        page: this.page,
        scrollLocation: scrollLocation,
        searchText: this.searchText,
      };

      sessionStorage.setItem(
        'visit_search_from_detail',
        JSON.stringify(visit_page),
      );
      // 페이지 이동 전에 세션스토리지에 저장 (뒤로가기 처리하기 위함) - 끝

      this.$router.push({
        name: 'Shops.Detail',
        params: {
          id: shopId,
        },
      });
    },
    async toggleFollow(shop, id, idx) {
      const self = this;
      const funAutoEstimationInProgress = async () => {
        await self[estimationTypes.FETCH_AUTO_ESTIMATION_IN_PROGRESS]({
          userId: self.currentUser.id,
          storeId: id,
        });
      };
      const funToggle = async function() {
        await self[
          shop.followed ? shopTypes.SHOP_UNFOLLOW : shopTypes.SHOP_FOLLOW
        ]({ id: id });
        //self.refresh();
        //페이지 중간에 새로고침하면 문제가 되니 관심매장체크만 변경해줘야함.
        // console.log(self.list, idx);
        self.list[idx].followed = !self.list[idx].followed;
      };
      if (shop.followed) {
        // 자동견적서 체크.
        await funAutoEstimationInProgress();
        if (self.autoEstimation.id) {
          self[commonActions.SET_DIALOG]({
            type: 'confirm',
            icon: 'warning',
            //title: this.$t('common.confirm'),
            message:
              '관심매장 해지시 자동견적서 발송이 취소 됩니다. 해지 하시겠습니까?',
            okCb: async () => {
              await funToggle();
              //this.$router.go(-1);
            },
          });
        } else {
          await funToggle();
        }
      } else {
        await funToggle();
      }
    },
    confirm() {},
  },
};
</script>
